import type { IconName } from "../components/Icon";

export type ErrorToast = {
  icon: IconName;
  message: string;
  buttonLabel: string;
};

type Listener = (toast: ErrorToast) => void;

const listeners = new Set<Listener>();

export function emitErrorToast(toast: ErrorToast): void {
  for (const listener of listeners) listener(toast);
}

export function subscribeErrorToasts(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
